import { useTranslation } from "react-i18next";
import { Button, Paper, Stack, Typography, styled } from "~/common/mui";
import { IMG_NO_RESULTS } from "~/utils/url/staticResources";

const StyledPaper = styled(Paper)({
  display: "flex",
  width: "100vw",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: 0,
  padding: "16px 24px",
  boxSizing: "border-box",
  zIndex: 1,
});

export const AccountSelectionBottomButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
  const { t } = useTranslation();
  return (
    <StyledPaper variant="elevation" elevation={3}>
      <Button disabled={disabled} fullWidth onClick={onClick}>
        {t("accountSelection.buttonText")}
      </Button>
    </StyledPaper>
  );
};

export const NoResultsFound = () => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" justifyContent="center" width="100%" sx={{ gap: 3, mt: 3 }}>
      <Typography variant="headlineLarge">{t("accountSelection.noResults.title")}</Typography>
      <img src={IMG_NO_RESULTS} alt={t("accountSelection.noResults.title")} />
      <Typography variant="bodyLarge" textAlign="center">
        {t("accountSelection.noResults.message")}
      </Typography>
    </Stack>
  );
};
